// Sticky-note body fills, keyed by the context-menu color name written via
// setElementColor (mutators/elements.js). Single source of truth shared by
// drawNote/drawNoteHidden (Canvas.jsx) and the EditableNote overlay so the
// two stay pixel-identical.
//
// Design: dark tinted body (not a pastel swatch) — each entry keeps
// luminance close to the neutral default so the light note text
// (rgb(227, 235, 236)) stays comfortably readable, with a clearly hued but
// muted tint at roughly consistent perceived saturation across hues.
// 'none' (and any undefined/unknown value) resolves to `default`.
export const NOTE_BODY_COLORS = {
    default: 'rgb(19, 20, 21)',
    blue: 'rgb(36, 55, 92)',
    green: 'rgb(33, 81, 49)',
    red: 'rgb(92, 36, 36)',
    purple: 'rgb(50, 33, 73)',
    violet: 'rgb(81, 32, 92)',
};

export const noteBodyColor = (color) => NOTE_BODY_COLORS[color] || NOTE_BODY_COLORS.default;
